/**
 * Route for `plan-pause-for-low-season-customers`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PlanPauseForLowSeasonCustomersPage } from "../features/plan-pause-for-low-season-customers/PlanPauseForLowSeasonCustomersPage";

export const planPauseForLowSeasonCustomersRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/plan-pause-for-low-season-customers",
	component: PlanPauseForLowSeasonCustomersPage,
});

export default planPauseForLowSeasonCustomersRoute;
